import { LoadingButton } from '@mui/lab'
import {
  Stack,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
} from '@mui/material'
import { useTranslation } from 'react-i18next'

type Props = {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  text: string
  title?: string
  confirmText?: string
  cancelText?: string
  isLoading?: boolean
}

export const ConfirmationDialog = ({
  title,
  text,
  open,
  onClose,
  onConfirm,
  confirmText,
  cancelText,
  isLoading,
}: Props) => {
  const { t } = useTranslation()
  const handleClose = () => {
    onClose()
  }

  const handleConfirm = () => {
    onConfirm()
    onClose()
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {title ?? t('confirmation-dialog')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">{text}</DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3 }}>
        <Stack
          width="100%"
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Button
            onClick={handleClose}
            variant="contained"
            style={{ color: '#fff', backgroundColor: 'rgb(3, 34, 76)' }}
            color="error"
          >
            {cancelText ?? t('cancel')}
          </Button>
          <LoadingButton
            loading={isLoading}
            onClick={handleConfirm}
            variant="contained"
            style={{ color: '#fff', backgroundColor: 'rgb(3, 34, 76)' }}
            color="primary"
            autoFocus
          >
            {confirmText ?? t('yes')}
          </LoadingButton>
        </Stack>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmationDialog
